import { useState } from 'react';
export const useSet = (initial = []) => {
    const [entries, setEntries] = useState(initial);
    return [entries, {
            has: (v) => entries.includes(v),
            add: (v) => setEntries(entries => entries.includes(v) ? entries : [...entries, v]),
            del: (v) => {
                let found = false;
                setEntries(entries => {
                    const i = entries.indexOf(v);
                    if (i >= 0) {
                        entries.splice(i, 1);
                        found = true;
                        return [...entries];
                    }
                    return entries;
                });
                return found;
            },
            clear: () => setEntries([]),
            reset: (v) => setEntries(v),
            toggle: (v) => {
                let added = false;
                setEntries(entries => {
                    const i = entries.indexOf(v);
                    if (i >= 0) {
                        entries.splice(i, 1);
                        return entries;
                    }
                    else {
                        added = true;
                        return [...entries, v];
                    }
                });
                return added;
            }
        }];
};
